import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

/** API Configure for UAT or Live  */
const config: any = {
  UATBaseURL: "https://uat-pwa.choicetechlab.com/api",
  UATEsignURL: "https://uat-pwa.choicetechlab.com",
  UATJFURL: "https://neurondevapi.choicetechlab.com/",
  UATMFURL: "https://uatapi.choicebroking.in/api/mf/",
  UATKYCBaseURL: "https://kyc-onboadingapi.choicetechlab.com/kycapi/",
  UATJiffyMiddlewareURL: "https://uatapi.choicebroking.in/api/middleware2/",
  UATSSOApiURL: "https://sso-api.choicetechlab.com/",
  /** for live pointed api */
  //  LiveBaseURL: "https://accounts.choiceindia.com/api",

  /**broking pointed  */
  // LiveBaseURL: "https://accounts.choicebroking.in/api",
  // LiveBaseURL: "http://20.1.50.217:8080/onBoardCore",
  
  /** while deploying production use this */
  LiveBaseURL: "https://accounts.choiceindia.com/api",
  // LiveBaseURL: "/api",
  LiveEsignURL: "https://accounts.choiceindia.com/",
  LiveJFURL: "https://neuronapi.choicetechlab.com/",
  LiveMFURL: "https://api.choiceindia.com/api/mf/",
  LiveAlphabeeEsignURL: "https://alphabee.choicebroking.in/",
  LiveKYCBaseURL: "https://accounts.choiceindia.com/kycapi/",
  // LiveKYCBaseURL: "https://accounts.choicebroking.in/kycapi/",
  LiveJiffyMiddlewareURL: "https://finx.choiceindia.com/api/middleware2/",
  LiveSSOApiURL: "https://sso-api.choiceindia.com/",
  UATPennyDropBaseURL: "https://kyc-onboadingapi.choicetechlab.com/kycapi/",
  LivePennyDropBaseURL: "https://accounts.choiceindia.com/kycapi/",
  LiveModificationURL: "https://accounts.choiceindia.com/",
  UATModificationURL: "https://accounts.choiceindia.com/"
};

/** Service Injectable */
@Injectable({ providedIn: "root" })
/** API URL list */
export class APIURLs {
  /** environment */
  private environment: string = "Live";
  /** version */
  public version: string = "v1.12.6.4";
  /**modification URL */
  private modificationURL: string = "";
  /** server URL  */
  private serverURL: string = "";
  /** esign Base URL */
  private esignBaseURL: string = "";
  /** penny Esign URL*/
  private pennyEsignURL: string = "";
  /** KYC Base URL */
  private KYCBaseURL: string = "";
  /** Jiffy Middleware URL */
  private JiffyMiddlewareURL: string = "";
  /** SSO Api URL */
  private SSOApiURL: string = "";
  /** Penny Drop Base URL */
  private PennyDropBaseURL: string = "";
  /** encrypt URL */
  private encryptURL: string = "/utility/list/encrypt";
  /** decrypt URL */
  private decryptURL: string = "/utility/list/decrypt";
  /** checkExistence URL */
  private checkExistenceURL: string = "/onboard/checkExistence";
  /** invDetails URL */
  private invDetailsURL: string = "/onboard/getInvestorDetails";
  /** register Investor URL */
  private registerInvestorURL: string =
    "/onboard/registerInvesticaUser?forceUpdate=$forceUpdate";
    /** PAN Details URL */
  private pANDetailsURL: string = "kra/get-pan-details";
  /** pan Details URL Version 2 */
  private panDetailsURLV2: string = "kra/get-pan-details/v2";
  /** lead City List URL */
  private leadCityListURL: string = "/onboard/getLeadCities";
  /** update Investor Details URL */
  private updateInvDetailsURL: string = "/onboard/updateClientDetails";
  /** bank List URL */
  private bankListURL: string = "/onboard/getBankList";
  /** branch List URL */
  private branchListURL: string = "/onboard/getBranchByBank/$bank";
  /** bank Details URL */
  private bankDetailsURL: string = "fetch-ifsc-detail/$ifsc";
  /** state List URL */
  private stateListURL: string = "/onboard/getState";
  /** iPV OTP URL */
  private iPVOTPURL: string = "/onboard/getIPVOTP";
  /** upload IPV URL */
  private uploadIPVURL: string = "/onboard/uploadIPV?newFileName=$newFileName";
  /** upload Document URL */
  private uploadDocURL: string =
    "/upload?newFileName=$newFileName&documentOf=$documentOf";
    /** upload Documents URL */
  private uploadDocsURL: string =
    "/onboard/multiUpload?newFileNames=$newFileNames&documentsOf=$documentsOf";
    /** upload AOF Documents URL */
  private uploadAOFDocsURL: string = "/onboard/uploadAofDocument";
  /** onboard Complete URL*/
  private onboardCompleteURL: string = "/onboard/onBoardComplete/$isEsignFlag";
  /** education List URL */
  private educationListURL: string = "/onboard/getEducationList";
  /** occupation List URL */
  private occupationListURL: string = "/onboard/getOccupationList";
  /** income Slab List URL */
  private incomeSlabListURL: string = "/onboard/getIncomeSlabList";
  /** update Screen URL */
  private updateScreenURL: string = "/onboard/addOnBoardingTracker";
  /** investorById URL */
  private investorByIdURL: string = "/investor/getById?id=$id";
  /** screen List URL */
  private screenListURL: string = "/onboard/getScreenList";
  /**  country List URL*/
  private countryListURL: string = "/onboard/getCountryList";
  /** document Base URL */
  private docBaseURL: string = "/files/$investorId/$fileName";
  /** delete Nominee URL */
  private deleteNomineeURL: string =
    "/onboard/deleteNomineeByInvestorId?id=$id";
    /** delete segments URL */
  private deleteSegmentsURL: string =
    "/onboard/deleteInvestorSegmentByInvestorId?id=$id";
    /** generate Forms URL */
  private generateFormsURL: string =
    "/onboard/generateforms?isESignFlag=$isEsignFlag";
    /**  bank Modification Request List URL*/
  private bankModificationRequestListURL: string =
    "/investorBankDetailsModified/getByInvestorIdAndApprovedFlag?investorId=$investorId&approvedFlag=$approvedFlag";
    /** segment Modification Request List URL  */
  private segmentModificationRequestListURL: string =
    "/modification/getByApprovedFlag?type=segment&isApprovedFlag=N&investorId=$investorId";
    /** address Modification Request List URL */
  private addressModificationRequestListURL: string =
    "/modification/getByApprovedFlag?type=address&isApprovedFlag=N&investorId=$investorId";
    /** nomiee Modification Request List URL */
  private nomieeModificationRequestListURL: string =
    "/modification/getByApprovedFlag?type=nomineeModification&isApprovedFlag=N&investorId=$investorId";
    /** esign URL */
  private esignURL: string = "/assets/esign.html?id=$id";
  /** support MF URL  */
  private supportMFURL: string = "static/SendEmail_V2";
  /** support JF URL */
  private supportJFURL: string = "contact/support";
  /** porting URL */
  private portingURL: string = "/onboard/port";
  /** porting URL  */
  private sendOTPURL: string = "/otp/send?panNum=$panNum";
  /** send OTP URL */
  private migrateDocURL: string =
    "/onboard/investorMigratingImage?sourceInvestorId=$sourceInvestor&destInvestorId=$destInvestor";
    /** delete Investor URL  */
  private deleteInvestorURL: string = "/onboard/deleteById?id=$id";
  /** delete ClientId URL */
  private deleteClientIdURL: string =
    "/investor/deleteByClientId?clientId=$clientId";
    /** validate OTP URL */
  private validateOTPURL: string =
    "/otp/verify?otp=$otp&newInvestorId=$newInvestorId&panNum=$panNum";
    /** recover Account URL */
  private recoverAccountURL: string =
    "/onboard/investicaRecover?panStr=$panStr&mobileNumber=$mobileNumber";
    /** generated Forms URL */
  private generatedFormsURL: string = "/forms/$formName";
  /** investor ByLeadId URL */
  private investorByLeadIdURL: string =
    "/investorDetails/getByLeadId?leadId=$leadId";
    /** investor ByPanClient URL */
  private investorByPanClientURL: string =
    "/neuron/getByPanOrClientId/$panOrClient/$businessUnit";
    /** send Modify OTP URL */
  private sendModifyOTPURL: string =
    "/segmentActivation/sendOTP?ssoSubjectId=$subjectId&mobileNum=$mobileNum&emailId=$emailId&purpose=$purpose";
  // private sendContactVerifyOTPUrl: string = "unified/send-otp";
  /** verify Modify OTP URL */
  private verifyModifyOTPURL: string =
    "/segmentActivation/verifyOTP?id=$investorId&otp=$otp&purpose=$purpose";
    /** check Mobile Number URL  */
  private checkMobileNumberURL: string =
    "/modification/checkMobileNum?mobileNum=$mobileNum";
    /** upload Modification File URL  */
  private uploadModificationFileURL: string =
    "/modification/upload?newFileName=$newFileName&documentOf=$documentOf";
    /** submit Modification Request URL  */
  private submitModificationRequestURL: string =
    "/modification/modifyClientDetails";
    /** generate Modification Form URL */
  private generateModificationFormURL: string =
    "/modification/modifyFormGenerate?isEmail=$isEmail";
    /** send Modification Email URL */
  private sendModificationEmailURL: string =
    "/modification/modifyEmailGenerate?formName=$formName";
    /** modify Esign URL */
  private modifyEsignURL: string = "/esign/kycesignRequest?id=$id&form=$form";
  /** emudhra Esign URL */
  private emudhraEsignURL: string = "/api/request?id=$id";
  /** brokerage Data URL */
  private brokerageDataURL: string = "/json/brokerage.json?q=$q";
  /** lang Data URL */
  private langDataURL: string = "/json/$lang.json?q=$q";
  /** send Onboard OTP URL */
  private sendOnboardOTPURL: string =
    // "/onboard/sendOTPNewOnboard?mobileNum=$mobileNum&emailId=$email";
    "unified/send-otp";
    /** verify Onboard OTP URL */
  private verifyOnboardOTPURL: string =
    // "/onboard/verifyOTPNewOnboard?otp=$otp&id=$id";
    "unified/verify-otp";
  
  /** account closure details api */
  private accountClosureDetails:string='account-closure/details';
    /** aadhar KYC URL */
  private aadharKYCURL: string = "/nsdlekyc/startEkycRequest?pan=$pan&id=$id";
  /** brokerage By ReferCode URL */
  private brokerageByReferCodeURL: string =
    "/brokerage/findBrokerageByReferredId?id=$id";
  // private pennyDropURL: string = '/pennyDrop/validateAdd?account=$account&ifsc=$ifsc&investorId=$id';
  /** Penny Drop */
  private pennyDropURL: string = "penny-drop";
  /** recover Client URL */
  private recoverClientURL: string = "/onboard/recoverClientIdByPAN/$pan";
  /** respond Issue URL*/
  private respondIssueURL: string = "/raiseIssue/respondIssue/$respondedBy";
  /**  location URL*/
  private locationURL: string =
    "https://maps.googleapis.com/maps/api/geocode/json?latlng=$latlng&result_type=sublocality_level_1&key=AIzaSyBxviqIPl6cmRLtkyoVlGMdo3-zq_gJ7N0";
    /** auth header */
  private authHeader: Object = { MF: "aW52ZXN0aWNh", JF: "amlmZnlBcHA=" };
  /** bu Brokerage Data URL */
  private buBrokerageDataURL: string =
    "https://ctl-ob-brokerage-$env.s3.ap-south-1.amazonaws.com/AlphabeeBrokerage.json";
    /** update Duplicate Lid Against Pan URL */
  private updateDuplicateLidAgainstPanURL: string =
    "/onboard/updateDuplicateLeadAgainstPan";
    /** referral Details URL */
  private referralDetailsURL: string =
    "/onboard/getReferralDetails?referredId=$id";
    /** bank Bazaar Update DetailsURL */
  private bankBazaarUpdateDetailsURL: string = "/onboard/bbUpdateClientDetails";
  
  /** upload Bank Bazaar Docs URL */
  private uploadBankBazaarDocsURL: string = "/onboard/multiUpload";
  
  /** delete New Lead Against Pan URL */
  private deleteNewLeadAgainstPanURL: string = "/leadMapping/changeLeadStatus";
  
  /** digio Doc Upload URL */
  private digioDocUploadURL: string =
    "/onboard/uploadDocumentToDigio?formName=$formName";
    /** digio Doc Download URL */
  private digioDocDownloadURL: string =
    "/onboard/downloadDigioDocument?formName=$formName&panNum=$pan&id=$docId";
    /** check Unique Mobile or Email URL*/
  private checkUniqueMobileEmailURL: string = "/onboard/checkUnique";
  /** IPV Sms URL */
  private IPVSmsURL: string = "/onboard/sendIPVSMS";
  /** generate KYC URL */
  private generateKYCURL: string = "generate-kyc-request";
  
  /** save KYC URL */
  private saveKYCURL: string = "save-kyc-details";
  
  /** send Respond OTP URL */
  private sendRespondOTPURL: string = "/raiseIssue/sendOTP";
  
  /** verifyRespondOTPURL */
  private verifyRespondOTPURL: string = "/raiseIssue/verifyOTP?otp=$otp";
  /** referral Code Validation URL */
  private referralCodeValidationURL: string =
    "/utility/validateReferral/$referralcode";
    /** pan Validate KYC URL*/
  private panValidateKYCURL: string = "pan-validate";
  /** education List V2 URL*/
  private educationListV2URL: string = "education/list";
  /** check Unique Mobile or Email Offline URL */
  private checkUniqueMobileEmailOfflineURL: string =
    "/onboard/checkUniqueOffline";
    /** Client Dormant */
  private isClientDormantURL: string = "CheckIsDormant";
  /** send OTP V2 URL */
  private sendOTPV2URL: string = "modification/send-otp";
  /** verify OTP V2 URL */
  private verifyOTPV2URL: string = "modification/verify-otp";
   /** send OTP AC URL */
  private sendOTPACURL: string = "account-closure/send-otp";
  /** verify OTP ACL */
  private verifyOTPACURL: string = "account-closure/verify-otp";
  /** Account closure  */
  private sendACEmailURL: string = "/account-closure/send-mail";
  /** masking URL */
  private maskingURL: string = "aadhar-masking";

  /**optimized state list url */
  private stateListURLV2: string = "state/list";
  /**optimized city list url */
  private cityListURLV2: string = "city/list?cityName=$cityname";
  /** modify Selfie*/
  private modifySelfie: string = "selfie-upload";

  /**endpoint url for generate access token api */
  private accessToken: string = "access/token";
  /**validation api */
  private validationURL: string = "user-validation";
 /** signature ocr */
  private signatureOCR : string = 'upload-sign'

  /**secure document download url */
  private fileDownloadURL : string = "preview/document"

  /**dp preference url */
  private updateDPPreference : string = "update-details"
  /** DP Preference*/
  private getDPPreference: string = "investor-details/$investorId"

    /** get all banks with logo */
    private getAllBanks: string = "bank/list";

      /** digio events log api url */
  private digioEventsURL: string = 'digio-event-logs';

    /**api url for genereate short link for segment and service modificaton */
    private generateShortLink: string = "modification/api/generate-link";
    /** sso email validation api  */
    private emailValidation:string = "validate-email";

    /** Account aggregator generate request */
    private generateUrl:string ="account-aggregator/generate-request"
    
    /**Account Closure Store Details */
    private storeDetails="account-closure/store";

    /** Initializes the component with default values. */
  constructor() {
    this.setServerURL();
    this.setEsignBaseURL();
    this.setKYCBaseURL();
    this.setJiffyMiddlewareBaseURL();
    this.setSSOApiURL();
    this.setPennyDropBaseURL();
    this.setModificationURL();
  }


/**
 * environment setup
 */
  private setServerURL() {
    this.serverURL = config[this.environment + "BaseURL"];
  }

  /**
   * environment setup
   */
  private setEsignBaseURL() {
    this.esignBaseURL =
      location.hostname.indexOf("localhost") == -1
        ? location.origin
        : this.serverURL;
    this.pennyEsignURL = config[this.environment + "EsignURL"];

    // (location.hostname.indexOf('accounts.') > -1 ? config[this.environment + 'EsignURL'] : location.hostname.indexOf('alphabee.') > -1) ? config[this.environment + 'AlphabeeEsignURL'] : config['UATEsignURL'];
  }
/**
 * environment setup
 */
  private setKYCBaseURL() {
    this.KYCBaseURL = config[this.environment + "KYCBaseURL"];
  }

  /**
 * Sets the base URL for Jiffy Middleware depending on the current environment.
 * This method retrieves the middleware URL from the configuration file based on the current environment
 * and assigns it to the `JiffyMiddlewareURL` property.
 */
private setJiffyMiddlewareBaseURL(): void {
  /** Sets the Jiffy Middleware URL for the current environment */
  this.JiffyMiddlewareURL = config[this.environment + "JiffyMiddlewareURL"];
}

/**
 * environment setup
 */
  private setSSOApiURL() {
    this.SSOApiURL = config[this.environment + "SSOApiURL"];
  }
  /**
 * environment setup
 */
  private setPennyDropBaseURL() {
    this.PennyDropBaseURL = config[this.environment + "PennyDropBaseURL"];
  }

  /**
 * environment setup
 */
  private setModificationURL() {
    this.modificationURL = config[this.environment + "ModificationURL"];
  }

/**
 * Get Version setup
 * @returns Version setup
 */
  getVersion() {
    return this.version;
  }
/**
 * Get Decrypt URL
 * @returns Respective API url
 */
  getDecryptURL() {
    return this.serverURL + this.decryptURL;
  }
/**
 * Get Encrypt URL
 * @returns Respective API url
 */
  getEncryptURL() {
    return this.serverURL + this.encryptURL;
  }
/**
 * Get CheckExistence URL
 * @returns Respective API url
 */
  getCheckExistenceURL(): string {
    return this.serverURL + this.checkExistenceURL;
  }
/**
 * Get Investor Details URL
 * @returns Respective API url
 */
  getInvDetailsURL(): string {
    return this.serverURL + this.invDetailsURL;
  }
/**
 * Get Register Investor URL
 * @param isForceProcess 
 * @returns Respective API url
 */
  getRegisterInvestorURL(isForceProcess?: string): string {
    return (
      this.serverURL +
      this.registerInvestorURL.replace("$forceUpdate", isForceProcess || "N")
    );
  }
/**
 * Get PAN Details URL
 * @returns Respective API url
 */
  getPANDetailsURL(): string {
    return this.KYCBaseURL + this.panDetailsURLV2;
    // return "https://accounts.choicebroking.in/kycapi/" + this.panDetailsURLV2
  }
/**
 * Get Lead City List URL
 * @returns Respective API url
 */
  getLeadCityListURL(): string {
    return this.serverURL + this.leadCityListURL;
  }
/**
 * Get Update InvDetails URL
 * @returns Respective API url
 */
  getUpdateInvDetailsURL(): string {
    return this.serverURL + this.updateInvDetailsURL;
  }
/**
 * Getting Bank List URL
 * @returns Respective API url
 */
  getBankListURL(): string {
    return this.serverURL + this.bankListURL;
  }
/**
 * Get Bank Details URL
 * @param ifsc Passing ifsc
 * @returns Respective API url
 */
  getBankDetailsURL(ifsc: string): string {
    return this.KYCBaseURL + this.bankDetailsURL.replace("$ifsc", ifsc);
  }
/**
 * Get Bank Branch List URL
 * @param bank Passing bank name
 * @returns Respective API url
 */
  getBranchListURL(bank: string): string {
    return this.serverURL + this.branchListURL.replace("$bank", bank);
  }
/**
 * Get State List URL
 * @returns Respective API url
 */
  getStateListURL(): string {
    return this.serverURL + this.stateListURL;
  }
/**
 * Get Education List URL
 * @returns Respective API url
 */
  getEducationListURL(): string {
    return this.serverURL + this.educationListURL;
  }
/**
 * Get OccupationList URL
 * @returns Respective API url
 */
  getOccupationListURL(): string {
    return this.serverURL + this.occupationListURL;
  }
/**
 * Get Income SlabList URL
 * @returns Respective API url
 */
  getIncomeSlabListURL(): string {
    return this.serverURL + this.incomeSlabListURL;
  }
/**
 * Get Screen List URL
 * @returns Respective API url
 */
  getScreenListURL(): string {
    return this.serverURL + this.screenListURL;
  }
/**
 * Get Update Screen URL
 * @returns Respective API url
 */
  getUpdateScreenURL(): string {
    return this.serverURL + this.updateScreenURL;
  }
/**
 * Get Country List URL
 * @returns Respective API url
 */
  getCountryListURL(): string {
    return this.serverURL + this.countryListURL;
  }
/**
 * Get Upload IPV URL
 * @param fileName Respective API url
 * @returns Respective API url
 */
  getUploadIPVURL(fileName: string): string {
    return this.serverURL + this.uploadIPVURL.replace("$newFileName", fileName);
  }
/**
 * Get IPV OTP URL
 * @returns Respective API url
 */
  getIPVOTPURL(): string {
    return this.serverURL + this.iPVOTPURL;
  }
/**
 * Get Upload Document URL
 * @param fileName passing file name
 * @param documentType Passing Document Type
 * @returns Respective API url
 */
  getUploadDocURL(fileName: string, documentType: string): string {
    return (
      this.serverURL +
      this.uploadDocURL
        .replace("$newFileName", fileName)
        .replace("$documentOf", documentType)
    );
  }
/**
 * Get Upload Documents URL
 * @param fileNames Passing fileNames
 * @param documentTypes Passing  documentTypes
 * @returns Respective API url
 */
  getUploadDocsURL(fileNames: string, documentTypes: string): string {
    return (
      this.serverURL +
      this.uploadDocsURL
        .replace("$newFileNames", fileNames)
        .replace("$documentsOf", documentTypes)
    );
  }
/**
 * Get Upload Aof URL
 * @returns Respective API url
 */
  getUploadAofURL(): string {
    return this.serverURL + this.uploadAOFDocsURL;
  }
  /**
   * Get Onboard Complete URL
   * @param isEsignFlag Passing isEsignFlag
   * @returns Respective API url
   */
  getOnboardCompleteURL(isEsignFlag?: string): string {
    return (
      this.serverURL +
      this.onboardCompleteURL.replace("$isEsignFlag", isEsignFlag || "N")
    );
    // return 'https://accounts.choicebroking.in/api' + this.onboardCompleteURL.replace('$isEsignFlag', isEsignFlag || 'N');
  }
/**
 * Get Delete Nominee URL
 * @param investorId Passing investorId
 * @returns Respective API url
 */
  getDeleteNomineeURL(investorId: string): string {
    return this.serverURL + this.deleteNomineeURL.replace("$id", investorId);
  }
/**
 * Get Delete Segment URL
 * @param investorId Pass investorId
 * @returns Respective API url
 */
  getDeleteSegmentURL(investorId: string): string {
    return this.serverURL + this.deleteSegmentsURL.replace("$id", investorId);
  }
/**
 * Get Generate Forms URL
 * @param isEsignFlag Passing isEsignFlag
 * @returns Respective API url
 */
  getGenerateFormsURL(isEsignFlag?: string): string {
    return (
      this.serverURL +
      this.generateFormsURL.replace("$isEsignFlag", isEsignFlag || "N")
    );
  }
  
  /** Account Closure Store Details */
  getstoreDetailsURL(){
    return this.KYCBaseURL + this.storeDetails;
  }
/**
 * Get Esign URL
 * @param investorId Passing investorId
 * @returns Respective API url
 */
  getEsignURL(investorId): string {
    return (
      this.esignBaseURL.replace("/api", "") +
      this.esignURL.replace("$id", investorId)
    );
  }
/**
 * Get Support URL
 * @param businessUnit Pass business Unit
 * @returns Respective API url
 */
  getSupportURL(businessUnit: string) {
    businessUnit = businessUnit == "MFJF" ? "JF" : businessUnit || "MF";
    let baseURL =
      location.hostname.indexOf("accounts.") > -1
        ? config[this.environment + (businessUnit + "URL")]
        : config["UAT" + (businessUnit + "URL")];
    return baseURL + this["support" + businessUnit + "URL"];
  }
/**
 * Get Porting URL
 * @returns Respective API url
 */
  getPortingURL(): string {
    return this.serverURL + this.portingURL;
  }
/**
 * Get Recover Account URL
 * @param pan Passing Pan Number
 * @param mobileNumber Passing Mobile Number
 * @returns Respective API url
 */
  getRecoverAccountURL(pan: string, mobileNumber: string): string {
    return (
      this.serverURL +
      this.recoverAccountURL
        .replace("$panStr", pan)
        .replace("$mobileNumber", mobileNumber)
    );
  }
/**
 * Get Validate OTP URL
 * @param panNum Passing Pan number
 * @returns Respective API url
 */
  getSendOTPURL(panNum: string): string {
    return this.serverURL + this.sendOTPURL.replace("$panNum", btoa(panNum));
  }
/**
 * Get Validate OTP URL
 * @param otp passing otp
 * @param investorId  Passing InvestorId
 * @param panNum  Passing Pan number
 * @returns Respective API url
 */
  getValidateOTPURL(otp: string, investorId: string, panNum: string): string {
    return (
      this.serverURL +
      this.validateOTPURL
        .replace("$otp", otp)
        .replace("$newInvestorId", investorId)
        .replace("$panNum", btoa(panNum))
    );
  }
/**
 * Get Authorization Header
 * @param businessUnit  Passing businessUnit
 * @returns Respective API url
 */
  getAuthorizationHeader(businessUnit?: string): string {
    businessUnit = businessUnit || this.getBusinessUnit();
    return this.authHeader[businessUnit];
  }
/**
 * Get BusinessUnit
 * @returns Respective API url
 */
  getBusinessUnit(): string {
    let href = location.href.toLowerCase();
    return href.indexOf("/mf/") > -1 || href.indexOf("/connect-mf/") > -1
      ? "MF"
      : href.indexOf("/trading/") > -1 ||
        href.indexOf("/connect-trading/") > -1 ||
        href.indexOf("/mf-trading/") > -1 ||
        href.indexOf("/connect-mf-trading/") > -1
      ? "JF"
      : "JF";
  }
/**
 * Get Migrate Document URL
 * @param sourceInvestorId Passing Source InvestorId
 * @param destInvestorId Passing Dest InvestorId
 * @returns Respective API url
 */
  getMigrateDocURL(sourceInvestorId: string, destInvestorId: string): string {
    return (
      this.serverURL +
      this.migrateDocURL
        .replace("$sourceInvestor", sourceInvestorId)
        .replace("$destInvestor", destInvestorId)
    );
  }
/**
 * Get Delete Investor URL
 * @param investorId passing investorId
 * @returns Respective API url
 */
  getDeleteInvestorURL(investorId: string) {
    return this.serverURL + this.deleteInvestorURL.replace("$id", investorId);
  }
/**
 * Get InvestorById URL
 * @param investorId Passing investorId
 * @returns Respective API url
 */
  getInvestorByIdURL(investorId: string) {
    return this.serverURL + this.investorByIdURL.replace("$id", investorId);
  }
/**
 * Get Delete ClientId URL
 * @param clientId Passing clientId
 * @returns Respective API url
 */
  getDeleteClientIdURL(clientId: string) {
    return (
      this.serverURL + this.deleteClientIdURL.replace("$clientId", clientId)
    );
  }
/**
 * Get Document Base URL
 * @param investorId Passing investor Id
 * @param fileName Passing file Name
 * @returns Respective API url
 */
  getDocBaseURL(investorId: string, fileName: string): string {
    let normalizedFileName = fileName;
    if (fileName && fileName.indexOf("/")) {
      let fileChunks = fileName.split("/");
      normalizedFileName = fileChunks[fileChunks.length - 1];
    }
    return (
      this.serverURL +
      this.docBaseURL
        .replace("$investorId", investorId)
        .replace("$fileName", normalizedFileName)
    );
  }
/**
 * Get Generated Form URL
 * @param fileName passing file Name
 * @returns Respective API url
 */
  getGeneratedFormURL(fileName: string) {
    return (
      this.serverURL + this.generatedFormsURL.replace("$formName", fileName)
    );
  }
/**
 * Get Investor ByLeadId URL
 * @param leadId Passing leadId
 * @returns Respective API url
 */
  getInvestorByLeadIdURL(leadId: string) {
    return (
      this.serverURL.replace("/api", "/leadManagement") +
      this.investorByLeadIdURL.replace("$leadId", leadId)
    );
  }
/**
 * Get Investor By Pan URL
 * @param panOrClient Passing pan Or Client
 * @param businessUnit Passing businessUnit
 * @returns Respective API url
 */
  getInvestorByPanClientURL(panOrClient: string, businessUnit?: any) {
    businessUnit = businessUnit || this.getBusinessUnit();
    return (
      this.serverURL +
      this.investorByPanClientURL
        .replace("$panOrClient", panOrClient)
        .replace("$businessUnit", businessUnit)
    );
  }
/**
 * Get Verify Modify OTP URL
 * @returns Respective API url
 */
  getVerifyModifyOTPURL() {
    return (
      this.KYCBaseURL +
      this.verifyOnboardOTPURL
    );
    // return "https://accounts.choicebroking.in/kycapi/unified/verify-otp"
  }
/**
 * Get Send Modify OTP URL
 * @param subjectId passing subjectId
 * @param purpose passing purpose
 * @param mobileNum passing mobileNum
 * @param emailId passing emailId
 * @returns Respective API url
 */
  getSendModifyOTPURL(
    subjectId: string,
    purpose: string,
    mobileNum: string,
    emailId: string
  ) {
    return (
      this.serverURL +
      this.sendModifyOTPURL
        .replace("$subjectId", subjectId)
        .replace("$purpose", purpose)
        .replace("$mobileNum", mobileNum)
        .replace("$emailId", emailId)
    );
  }
/**
 * Get Send Contact Verify OTP URL
 * @returns Respective API url
 */
  getSendContactVerifyOTPURL() {
    return(
      this.KYCBaseURL + this.sendOnboardOTPURL
      )
      // return 'https://accounts.choicebroking.in/kycapi/unified/send-otp'
  
  }
/**
 * Get Upload Modification File URL
 * @param fileName Passing file name
 * @param documentType Passing document Type
 * @returns Respective API url
 */
  getUploadModificationFileURL(fileName: string, documentType: string): string {
    return (
      this.serverURL +
      this.uploadModificationFileURL
        .replace("$newFileName", fileName)
        .replace("$documentOf", documentType)
    );
  }
  /**
   * Get Check Mobile Number URL
   * @param mobileNumber Passing MobileNumber
   * @returns Respective API url
   */
  getCheckMobileNumberURL(mobileNumber: string) {
    return (
      this.serverURL +
      this.checkMobileNumberURL.replace("$mobileNum", mobileNumber)
    );
  }
/**
 * Get Submit Modification Request URL
 * @returns Respective API url
 */
  getSubmitModificationRequestURL() {
    return this.serverURL + this.submitModificationRequestURL;
  }
/**
 * Get Generte Modification Form URL
 * @param isEmail 
 * @returns Respective API url
 */
  getGenerteModificationFormURL(isEmail?: string) {
    return (
      this.serverURL +
      this.generateModificationFormURL.replace("$isEmail", isEmail)
    );
  }
/**
 * get Send Modification Email URL
 * @param formName passing form value
 * @returns Respective API url
 */
  getSendModificationEmailURL(formName: string) {
    return (
      this.serverURL +
      this.sendModificationEmailURL.replace("$formName", formName)
    );
  }
/**
 * get Modify Esign URL
 * @param investorId passing investor Id
 * @param form passing form
 * @returns Respective API url
 */
  getModifyEsignURL(investorId: string, form: string): string {
    return (
      this.esignBaseURL +
      this.modifyEsignURL.replace("$id", investorId).replace("$form", form)
    );
  }
/**
 * get Emudhra Esign URL
 * @param investorId 
 * @returns Respective API url
 */
  getEmudhraEsignURL(investorId: string): string {
    return (
      "https://emudhra.choicebroking.in" +
      this.emudhraEsignURL.replace("$id", investorId)
    );
  }
/**
 * get Bank Modification Request  List URL
 * @param investorId 
 * @param approvedFlag 
 * @returns Respective API url
 */
  getBankModificationRequestListURL(investorId: string, approvedFlag?: string) {
    return (
      this.serverURL +
      this.bankModificationRequestListURL
        .replace("$investorId", investorId)
        .replace("$approvedFlag", approvedFlag || "N")
    );
  }
/**
 * get Segment Modification Request List URL
 * @param investorId passing Investor Id
 * @param approvedFlag passing Approved Flag
 * @returns Respective API url
 */
  getSegmentModificationRequestListURL(
    investorId: string,
    approvedFlag?: string
  ) {
    return (
      this.serverURL +
      this.segmentModificationRequestListURL.replace("$investorId", investorId)
    );
  }
/**
 * Get Address Modification Request List URL
 * @param investorId passing investor Id
 * @param approvedFlag passing approved Flag
 * @returns Respective API url
 */
  getAddressModificationRequestListURL(
    investorId: string,
    approvedFlag?: string
  ) {
    return (
      this.serverURL +
      this.addressModificationRequestListURL.replace("$investorId", investorId)
    );
  }
/**
 * get Nominee Modification Request List URL
 * @param investorId passing  investor Id
 * @param approvedFlag passing approved Flag
 * @returns Respective API url
 */
  getNomineeModificationRequestListURL(
    investorId: string,
    approvedFlag?: string
  ) {
    return (
      this.serverURL +
      this.nomieeModificationRequestListURL.replace("$investorId", investorId)
    );
  }
/**
 * get Brokerage Data URL
 * @returns Respective API url
 */
  getBrokerageDataURL() {
    return this.brokerageDataURL.replace("$q", new Date().valueOf() + "");
  }
/**
 * get Send Onboard OTP URL
 * @returns Respective API url
 */
  getSendOnboardOTPURL() {
    return (
      // "https://accounts.choicebroking.in/kycapi/unified/send-otp"
      this.KYCBaseURL + this.sendOnboardOTPURL
    
    );
  }
/**
 * get Verify Onboard OTP URL
 * @returns Respective API url
 */
  getVerifyOnboardOTPURL() {
    return (
      // "https://accounts.choicebroking.in/kycapi/unified/verify-otp"
      this.KYCBaseURL + this.verifyOnboardOTPURL
    );
  }
/**
 * get Aadhaar KYC URL
 * @param investorId paasing investorId
 * @param panNum passing pan Number
 * @returns Respective API url
 */
  getAadharKYCURL(investorId: string, panNum: string) {
    return (
      this.esignBaseURL +
      this.aadharKYCURL.replace("$id", investorId).replace("$pan", panNum)
    );
  }
/**
 * get Brokerage By ReferCode URL
 * @param referCode passing referCode
 * @returns Respective API url
 */
  getBrokerageByReferCodeURL(referCode: string) {
    return (
      this.serverURL + this.brokerageByReferCodeURL.replace("$id", referCode)
    );
  }
/**
 * get penny DropURL
 * @returns Respective API url
 */
  getpennyDropURL() {
    return this.PennyDropBaseURL + this.pennyDropURL;
  }
/**
 * get Recover Client URL
 * @param pan Respective API url
 * @returns espective API url
 */
  getRecoverClientURL(pan: string) {
    return this.serverURL + this.recoverClientURL.replace("$pan", pan);
  }
/**
 * get Respond Issue URL
 * @param respondedBy get responded value
 * @returns Respective API url
 */
  getRespondIssueURL(respondedBy: string) {
    return (
      this.serverURL + this.respondIssueURL.replace("$respondedBy", respondedBy)
    );
  }
/**
 * get Location URL
 * @param latlng passing language
 * @returns Respective API url
 */
  getLocationURL(latlng: string) {
    return this.locationURL.replace("$latlng", latlng);
  }
/**
 *  get Lang Data URL
 * @param language  passing language
 * @returns Respective API url
 */
  getLangDataURL(language: string) {
    return this.langDataURL
      .replace("$lang", language)
      .replace("$q", new Date().valueOf() + "");
  }
/**
 * get BUBrokerag eData URL
 * @returns Respective API url
 */
  getBUBrokerageDataURL() {
    let env =
      location.hostname.indexOf("accounts.choiceindia.com") > -1 ||
      location.hostname.indexOf("accounts.choicebroking.in") > -1 ||
      this.serverURL == "https://accounts.choiceindia.com/api" ||
      this.serverURL == "https://accounts.choicebroking.in/api"
        ? "prod"
        : "uat";
    return this.buBrokerageDataURL.replace("$env", env);
  }
/**
 * get update Duplicate Lid Against Pan URL
 * @returns Respective API url
 */
  getupdateDuplicateLidAgainstPanURL(): string {
    return this.serverURL + this.updateDuplicateLidAgainstPanURL;
  }
/**
 * get referral Details URL
 * @param id passing id
 * @returns Respective API url
 */
  getreferralDetailsURL(id): string {
    return this.serverURL + this.referralDetailsURL.replace("$id", id);
  }
/**
 * get BankBazaar Update Details URL
 * @returns Respective API url
 */
  getBankBazaarUpdateDetailsURL(): string {
    return this.serverURL + this.bankBazaarUpdateDetailsURL;
  }
/**
 * get BankBazaar Upload Docs URL
 * @returns Respective API url
 */
  getBankBazaarUploadDocsURL(): string {
    return this.serverURL + this.uploadBankBazaarDocsURL;
  }
/**
 * get delete NewLead Against Pan URL
 * @returns Respective API url
 */
  getdeletNewLeadAgainstPanURL(): string {
    return (
      this.serverURL.replace("/api", "/leadManagement") +
      this.deleteNewLeadAgainstPanURL
    );
  }
/**
 * get Unique Check URL
 * @returns Respective API url
 */
  getUniqueCheckURL(): string {
    return this.serverURL + this.checkUniqueMobileEmailURL;
  }
/**
 * Getting base url
 * @returns Respective API url
 */
  getBaseURL(): string {
    return this.serverURL;
    // return "https://accounts.choicebroking.in/api";
  }
/**
 * get IPV Sms URL
 * @returns Respective API url
 */
  geIPVSmsURL(): string {
    return this.serverURL + this.IPVSmsURL;
  }
/**
 * get Digio Document Upload Url
 * @returns Respective API url
 */
  getDigioDocUploadUrl(): string {
    return this.serverURL + this.digioDocUploadURL;
  }
/**
 * get Digio Document Download Url
 * @param pan passing pan number
 * @param docId passing document id
 * @param formName passing form name
 * @returns Respective API url
 */
  getDigioDocDownloadUrl(pan, docId, formName): string {
    return (
      this.serverURL +
      this.digioDocDownloadURL
        .replace("$pan", pan)
        .replace("$docId", docId)
        .replace("$formName", formName)
    );
  }
/**
 * Generate KYC URL
 * @returns Respective API url
 */
  getGenerateKYCURL(): string {
    return this.KYCBaseURL + this.generateKYCURL;
  }
/**
 * Save KYC URL
 * @returns Respective API url
 */
  getSaveKYCURL(): string {
    return this.KYCBaseURL + this.saveKYCURL;
  }
/**
 * set Environment
 * @returns environment setup
 */
  getEnvironment(): string {
    return this.environment;
  }
/**
 * Send Respond OTP URL
 * @returns Respective API url
 */
  getSendRespondOTPURL() {
    return this.serverURL + this.sendRespondOTPURL;
  }
/**
 * Verify Respond OTP URL
 * @param otp 
 * @returns Respective API url
 */
  getVerifyRespondOTPURL(otp: string) {
    return this.serverURL + this.verifyRespondOTPURL.replace("$otp", otp);
  }

  /**
   * Referral Validation URL
   * @param referralCode 
   * @returns Respective API url
   */
  getReferralValidationURL(referralCode: string) {
    return (
      this.serverURL.replace("/api", "/leadManagement") +
      this.referralCodeValidationURL.replace("$referralcode", referralCode)
    );
  }


/**
 * Pan Validate KYC URL
 * @returns passing API url
 */
  getPanValidateKYCURL(): string {
    return this.KYCBaseURL + this.panValidateKYCURL;
    // return "https://accounts.choicebroking.in/kycapi/" + this.panValidateKYCURL;
  }
/**
 * Education List V2 URL
 * @returns Passing API url
 */
  getEducationListV2URL(): string {
    return this.KYCBaseURL + this.educationListV2URL;
  }
/**
 * Client Dormant URL
 * @returns Passing API url
 */
  getIsClientDormantURL() {
    // 'https://jiffy.choiceindia.com/api/middleware2/'
    return this.JiffyMiddlewareURL + this.isClientDormantURL;
  }

/**
 * unique check in offline url
 * @returns Passing API url
 */
  getUniqueCheckOfflineURL(): string {
    return this.serverURL + this.checkUniqueMobileEmailOfflineURL;
  }

  /**
 * Returns the URL for sending OTP (version 2).
 * This method provides the API endpoint for sending OTP requests.
 * @returns The URL for sending OTP requests.
 */
  getSendOTPV2URL(): string {
    return this.KYCBaseURL + this.sendOnboardOTPURL;
    // return 'https://accounts.choicebroking.in/kycapi/unified/send-otp'
  }

  /**
 * Returns the URL for verify OTP (version 2).
 * This method provides the API endpoint for verify OTP requests.
 * @returns The URL for sending OTP requests.
 */
  getVerifyOTPV2URL(): string {
    return this.KYCBaseURL + this.verifyOnboardOTPURL;
    // return "https://accounts.choicebroking.in/kycapi/unified/verify-otp"
  }

   /**
 * Returns the URL for sending OTP account closer.
 * This method provides the API endpoint for sending OTP requests.
 * @returns The URL for sending OTP requests.
 */
  getSendOTPACURL(): string {
    return this.KYCBaseURL + this.sendOnboardOTPURL;
    // return 'https://accounts.choicebroking.in/kycapi/unified/send-otp'
  }

    /**
 * Returns the URL for verify OTP.
 * This method provides the API endpoint for verify OTP requests.
 * @returns The URL for sending OTP requests.
 */
  getVerifyOTPACURL(): string {
    return this.KYCBaseURL + this.verifyOnboardOTPURL;
    // return "https://accounts.choicebroking.in/kycapi/unified/verify-otp"
  }

  /**Account Closure Details */
  getAccountClosureDetailsUrl(){
    //return this.KYCBaseURL + this.accountClosureDetails;
    return this.KYCBaseURL + this.accountClosureDetails;
  }
/**
 * Account Closure email url
 * @param formName 
 * @returns  Passing API url
 */
  getACEmailURL(formName: string): string {
    return this.serverURL.replace("api", "kycapi") + this.sendACEmailURL;
  }
  /**
   * Adhaar masking API
   * @returns  Passing API url
   */
  getAdhaarMasking(): string {
    return this.KYCBaseURL + this.maskingURL;
  }
/**
 * Getting state list API
 * @returns  Passing API url
 */
  getStatesListURLV2() {
    return this.KYCBaseURL + this.stateListURLV2;
  }

  /**
   *  Getting lead City list API
   * @param cityname 
   * @returns  Passing API url
   */

  getLeadCityListURLV2(cityname: string) {
    return this.KYCBaseURL + this.cityListURLV2.replace("$cityname", cityname);
    // return  cityname? this.KYCBaseURL + this.cityListURLV2.replace('$cityname', cityname) :this.KYCBaseURL + this.cityListURLV2.replace("?cityName=$cityname", '') ;
  }
/**
 * selfie modify url
 * @returns  Passing API url
 */
  getModifySelfieURL(): string {
    return this.KYCBaseURL + this.modifySelfie;
  }

  /**
   * Generate access token api
   * @returns  Passing API url
   */
  generateAccessTokenURL(): string {
    // return "https://accounts.choicebroking.in/kycapi/access/token";
    // return this.SSOApiURL + this.accessToken;
    return this.KYCBaseURL + this.accessToken;
  }
  /**
   * all field validation api
   * @returns  Passing API url
   */
  getValidationURL(): string {
    return this.KYCBaseURL + this.validationURL;
  }
  /**
   * Signature ocr API
   * @returns  Passing API url
   */
getSignatureOcrURL(): string {

    return this.KYCBaseURL + this.signatureOCR

  }

  /**
   * for document download API
   * @returns  Passing API url
   */
  getSecureFileDownloadURL(): string{
    return this.KYCBaseURL + this.fileDownloadURL;
  }

/**
 * update DP preference API 
 * @returns  Passing API url
 */
  getUpdateDPPreferenceURL(): string{
    // return "https://accounts.choicebroking.in/kycapi/update-details"
    return this.KYCBaseURL + this.updateDPPreference;
  }

/**
 * Dp preference API
 * @param investorId passing investor Id 
 * @returns Dp preference API
 */

  getSetterDPPreferenceURL(investorId: any) : string{
    // return `https://accounts.choicebroking.in/kycapi/investor-details/${investorId}`
    return this.KYCBaseURL + this.getDPPreference.replace('$investorId',investorId);
  }

/**
 * getting all bank API 
 * @returns  Passing API url
 */
  getAllBanksURL() : string {
    return this.KYCBaseURL + this.getAllBanks;
  }
/**
 * Digio event log API call
 * @returns  Passing API url
 */
  getDigioEventsUrl(): string {
   return this.KYCBaseURL + this.digioEventsURL;
    // return 'https://accounts.choicebroking.in/kycapi/digio-event-logs' //this.KYCBaseURL + this.digioEventsURL;
  }

/**
 * Generate modification link
 * @returns  Passing API url
 */
  getNewModificationLink(){
    return this.modificationURL + this.generateShortLink;
    // return 'https://accounts.choicebroking.in/' + this.generateShortLink
  }

  /**
   * email validation
   * @returns  Passing API url
   */
  getValidateEmail(){

    return this.KYCBaseURL + this.emailValidation
    
  }
  
/**
 * configure validation Id
 * @returns liveAuthEmail or uatAuthEmail value
 */
  getValidationId(){
    return ''
  }
/** account aggregator generate link url */

  generateRequest(){
    return this.KYCBaseURL + this.generateUrl

    // return 'https://accounts.choicebroking.in/kycapi/' + this.generateUrl
  }
}
